import isElementVisible from './isElementVisible'
import IsVisibleWatcher, { IsVisibleWatcherNodeState } from './IsVisibleWatcher'

const hiders = [
  {
    selector: '[data-clientside-hook="stickyBuyBox"]',
    checkChildren: true,
  },
  {
    selector: '[data-clientside-hook="sticky-cta"]',
    checkChildren: true,
  },
  {
    selector: '[data-qa-id="suggest-list"]',
    checkChildren: true,
  },
  {
    selector: '[data-clientside-hook="SearchBoxMobileContainer"].active',
    checkChildren: true,
  },
].filter((hider) => Boolean(hider.selector))

function determineVisibility(): boolean {
  return !hiders.filter(Boolean).some(({ selector, checkChildren }) => {
    const element = document.querySelector(selector)
    return element ? isElementVisible(element, checkChildren) : false
  })
}

function determineMarginBottom(): string {
  const withNlBanner = document.body.classList.contains('withNlBanner')
  const banner =
    document.querySelector('[data-clientside-hook="stickyBanner"]') ||
    document.getElementById('ab-sticky-nl')

  if (withNlBanner && banner) {
    const { height } = banner.getBoundingClientRect()

    return `${height + 8}px`
  }

  return '8px'
}

function setMarginBottom(root: HTMLElement): void {
  Object.assign(root.style, {
    marginBottom: determineMarginBottom(),
  })
}

export const setupRootStyle = (root: HTMLElement) => {
  setMarginBottom(root)

  const observer = new MutationObserver((mutationList) => {
    if (mutationList.some((mutation) => mutation.type === 'attributes')) {
      setMarginBottom(root)
    }
  })
  observer.observe(document.body, { attributes: true })

  let throttle: NodeJS.Timeout
  window.addEventListener('resize', () => {
    clearTimeout(throttle)

    throttle = setTimeout(() => {
      setMarginBottom(root)
    }, 250)
  })

  // eslint-disable-next-line no-param-reassign
  root.hidden = !determineVisibility()

  Object.assign(root.style, {
    position: 'fixed',
    zIndex: '1299',
    left: '10px',
    top: '10px',
    width: CSS.supports('width: calc(1em)') ? 'calc(100% - 20px)' : '100%',
    height: '0',
    textAlign: 'right',
  })

  if (CSS.supports('pointer-events: none')) {
    Object.assign(root.style, {
      pointerEvents: 'none',
      top: '10px',
      left: '10px',
      bottom: '10px',
      right: '10px',
      height: 'auto',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      alignItems: 'flex-end',
    })

    // eslint-disable-next-line no-unused-expressions
    root.clientHeight

    Object.assign(root.style, {
      transition: 'margin-bottom 0.3s cubic-bezier(0.3, -0.4, 0, 1.5)',
    })
  }
}

export const startRootStyleWatchers = (root: HTMLElement) => {
  // eslint-disable-next-line no-new
  new IsVisibleWatcher({
    targetSelectors: hiders.map((hider) => hider.selector),
    checkResultCallback: (stateArray) => {
      const isVisible = !stateArray.some(
        (state) => state.state === IsVisibleWatcherNodeState.Visible
      )
      // eslint-disable-next-line no-param-reassign
      root.hidden = !isVisible
    },
  })
}
